import { Box } from "@mui/material";
import startImg from "../../assets/instruction/play_icon.png";
import pauseImg from "../../assets/instruction/pause_icon.png";

function InstructionsFil() {
	return (
		<>
			<Box className="instruction-container">
				<h1>Pagunawa ng inyong mga Karapatan bilang isang pinansyal na konsyumer</h1>
				<p style={{ marginTop: "1rem", fontSize: "1rem" }}>
					Kumusta! Maligayang pagdating sa Quick Learning Tool No. 6: Pagunawa ng inyong mga
					Karapatan bilang isang pinansyal na konsyumer
					<br />
					<br />
					Ang pag-navigate sa larangan ng panansyal ay maaaring maging kumplikado, at ang pagiging
					mulat sa iyong mga karapatan ay makakapagbigay sa atin ng kalayaan.
				</p>
				<br />
				<br />
				<h2>Gabay</h2>
				<p style={{ marginTop: "1rem", fontSize: "1rem" }}>
					Simulan sa pamamagitan ng pag-click sa "Simula" na button upang simulan ang pag-uusap.
					<br />
					<br />
					Sa ilang pagkakataon, ipapakita sa iyo ang mga tanong na may kinalaman sa iyong mga
					karapatan bilang isang pinansyal na konsyumer. Sagutin ang mga tanong upang magpatuloy.
					<br />
					<br />
					Kapag kailangan mong huminto, i-click ang icon na ito{" "}
					<img
						src={pauseImg}
						alt="pasue"
						style={{
							cursor: "pointer",
							marginLeft: "5px",
							height: ".7rem",
						}}
					/>
					. Ito ay pansamantalang titigil sa kasalukuyang usapan. I-click ang{" "}
					<img
						src={startImg}
						alt="start"
						style={{
							cursor: "pointer",
							marginLeft: "5px",
							marginRight: "5px",
							height: ".7rem",
						}}
					/>{" "}
					upang magpatuloy mula sa kung saan ka huling huminto.
					<br />
					<br />
					Kapag tapos na, i-click ang "Finish".
				</p>
			</Box>
		</>
	);
}

export default InstructionsFil;
